import React, { createContext, useContext, useCallback, useEffect, useState, useMemo } from 'react';

const FeatureFlagContext = createContext({ flags: {}, loading: true, isEnabled: () => true, refresh: () => {} });

export const MODULE_DEFINITIONS = [
  { key: 'module_dashboard', label: 'Dashboard', category: 'app' },
  { key: 'module_journal', label: 'Trade Journal', category: 'app' },
  { key: 'module_academy', label: 'Academy', category: 'app' },
  { key: 'module_mentor_academy', label: 'Mentor Academy', category: 'app' },
  { key: 'module_sentiment', label: 'Sentiment', category: 'app' },
  { key: 'module_news', label: 'Nyhetsfeed', category: 'app' },
  { key: 'module_option_flow', label: 'Option Flow', category: 'app' },
  { key: 'module_watchlist', label: 'Watchlist', category: 'app' },
  { key: 'module_leaderboard', label: 'Leaderboard', category: 'app' },
  { key: 'module_trade_ideas', label: 'Trade Ideas', category: 'app' },
  { key: 'module_trading_rooms', label: 'Trading Rooms', category: 'app' },
  { key: 'module_copy_trading', label: 'Copy Trading', category: 'app' },
  { key: 'module_flockcopy', label: 'FlockCopy — visible in menu', category: 'app' },
  { key: 'module_flockcopy_use', label: 'FlockCopy — can use (else upgrade wall)', category: 'app' },
  { key: 'module_signals', label: 'Signals', category: 'app' },
  { key: 'module_direct_messages', label: 'Direktemeldinger', category: 'app' },
  { key: 'module_mentor_apply', label: 'Mentor-søknad', category: 'app' },
  { key: 'module_competitions', label: 'Konkurranser', category: 'app' },
  { key: 'module_price_alerts', label: 'Prisalerts', category: 'app' },
  { key: 'module_forex_calendar', label: 'Forex Calendar', category: 'app' },
];

export const FeatureFlagProvider = ({ children }) => {
  const [flags, setFlags] = useState({});
  const [loading, setLoading] = useState(true);

  const fetchFlags = useCallback(async () => {
    try {
      const res = await fetch('/api/feature-flags', { credentials: 'include' });
      if (res.ok) {
        const data = await res.json();
        setFlags(data);
      }
    } catch {
      // Fail silently — all features default to enabled
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchFlags();
  }, [fetchFlags]);

  const isEnabled = useCallback(
    (key) => {
      if (!(key in flags)) return true; // Unknown flags default to enabled
      return flags[key] === true;
    },
    [flags]
  );

  const value = useMemo(() => ({ flags, loading, isEnabled, refresh: fetchFlags }), [flags, loading, isEnabled, fetchFlags]);

  return (
    <FeatureFlagContext.Provider value={value}>
      {children}
    </FeatureFlagContext.Provider>
  );
};

export const useFeatureFlags = () => useContext(FeatureFlagContext);

export default FeatureFlagContext;
